export default "__VITE_ASSET__Dx5PpG3M__"